import React from 'react';
import {AisinoFormItem, AisinoRadio, AisinoRadioGroup} from "../../../baseComponent/form";
import {AisinoCol} from "../../../baseComponent/rowAndCol";
import {postSync} from "../../utils/http";
import {formItemTailLayout} from "../../../constant/css";

let radioOptions = {};
class FormItemDictRadio extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            optionsData: '',
        };
    }

    componentDidMount() {
        const typeCode = this.props.typecode;

        const optionList =  radioOptions[typeCode.toString()];
        //判断选项是否已存在，如果存在，直接用；
        // 如果不存在，从后台接口查询，并保存数据字典 radioOptions变量里（已备下次使用，减少接口调用，优化体验）
        if (optionList){
            this.setOptionsData(optionList);
        } else {

            postSync('aisino/portalIndex/getDictByTypeCode', {typeCode:typeCode}).then(response => {
                //console.log("FormItemDictRadio==optionList=="+JSON.stringify(response));
                if (response) {
                    const optionList = response;
                    this.setOptionsData(optionList);
                     radioOptions[typeCode.toString()] = optionList;
                }
            });
        }
    }

    componentWillUnmount() {
        this.setState = ()=>false;
    }


    setOptionsData(optionList){
        let children = [];
        for (let i = 0; i < optionList.length; i++) {
            if(this.props.horizontal){
                children.push(<AisinoRadio  key={optionList[i].name} value={optionList[i].value}>{optionList[i].name}</AisinoRadio>);
            }else{
                children.push(<AisinoCol span={24}>
                    <AisinoRadio  key={optionList[i].name} value={optionList[i].value}>{optionList[i].name}</AisinoRadio>
                </AisinoCol>);
            }
        }
        this.setState({optionsData:children});
    }

    onChange = e => {
        // console.log('radio checked', e.target.value);
        this.setState({
            value: e.target.value,
        });
    };

    render() {
        return(
            <AisinoFormItem {...formItemTailLayout}
                            {...this.props} onChange={this.props.onChangeItem}>
                <AisinoRadioGroup onChange={this.onChange} value={this.state.value} {...this.props}>
                    {this.state.optionsData}
                </AisinoRadioGroup>
            </AisinoFormItem>
        );
    }
}

export default FormItemDictRadio;